const refreshPage = () => {
  window.location.reload();
};

const printPage = (e) => {
  e.stopPropagation();
  window.print();
};

export { refreshPage, printPage };
